import api from './base'
import { objectToQueryString } from '../utils/object'

export default {
  getAll ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/current_stock?${objectToQueryString(filters)}`)
  },
  getByArticle ({ businessUnitId, articleId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/current_stock/articles/${articleId}?${objectToQueryString(filters)}`)
  },
  getPdf ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/current_stock/pdf?${objectToQueryString(filters)}`)
  }
}
